import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { ChangePasswordPageComponent } from './change-password-page/change-password-page.component';
import { SettingsGeneralComponent } from './settings-general/settings-general.component';
import { SettingsHelpComponent } from './settings-help/settings-help.component';
import { SettingsProfileComponent } from './settings-profile/settings-profile.component';
import {
  PATH_CHANGE_PASSWORD,
  PATH_SETTINGS,
  PATH_SETTINGS_GENERAL,
  PATH_SETTINGS_HELP,
} from './settings.global';
import { SettingsPageComponent } from './settings-page/settings-page.component';
import { AuthGuard } from '../calvin-emr-shared/guards/auth.guard';
import { PATH_LOGIN } from 'src/app/login/login.global';

export const settingsRoutes: Routes = [
  {
    path: PATH_SETTINGS,
    component: SettingsPageComponent,
    canActivateChild: [() => inject(AuthGuard).canActivateChild(PATH_LOGIN)],
    children: [
      { path: '', component: SettingsProfileComponent },
      { path: PATH_SETTINGS_GENERAL, component: SettingsGeneralComponent },
      { path: PATH_SETTINGS_HELP, component: SettingsHelpComponent },
      { path: PATH_CHANGE_PASSWORD, component: ChangePasswordPageComponent },
    ],
  },
  {
    path: PATH_CHANGE_PASSWORD,
    component: ChangePasswordPageComponent,
  },
];
